
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCES'
export const AUTH_FAILED = 'AUTH_FAILED'
export const AUTH_LOGOUT= 'AUTH_LOGOUT'
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH'

export const UPDATE_START = 'UPDATE_START'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const UPDATE_FAILED = 'UPDATE_FAILED'

export const ADD_INCOME = 'ADD_INCOME'
export const ADD_EXPENSE = 'ADD_EXPENSE'
export const POST_START = 'POST_START'
export const POST_SUCCESS = 'POST_SUCCESS'
export const POST_FAILED = 'POST_FAILED'

export const DELETE_INCOME_ENTRY= 'DELETE_INCOME_ENTRY'
export const DELETE_EXPENSE_ENTRY= 'DELETE_EXPENSE_ENTRY'

// export const REMOVE_ENTRY_FROM_DB = 'REMOVE_ENTRY_FROM_DB'


export const FETCH_DATA_START = 'FETCH_DATA_START'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const FETCH_DATA_FAILED = 'FETCH_DATA_FAILED'
export const CLEAR_STATE = 'CLEAR_STATE'

export const DELETE_LABEL = 'DELETE_LABEL'
export const ADD_LABEL = 'ADD_LABEL'
